export const SET_LOADING = 'SET_LOADING'
export const SET_ORDER = 'SET_ORDER'
export const SET_SETTING_ORDER = 'SET_SETTING_ORDER'

export const SET_TITLES = 'SET_TITLES'
export const CREATE_TITLE = 'CREATE_TITLE'
export const UPDATE_TITLE = 'UPDATE_TITLE'
export const REMOVE_TITLE = 'REMOVE_TITLE'
export const INSERT_TITLES_BEFORE = 'INSERT_TITLES_BEFORE'
